export default "__VITE_ASSET__CSUTcmvj__"